import styled from 'styled-components';

// export const HomeMain = styled.div`
//     background-color: var(--theme-color-secondary);
//     display: flex;
//     flex-direction: column;
//     gap: 40px;
//     border-radius: 16px;
//     padding: 20px;
// `;

export const HomeCardsMain = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const HomeCardsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;

    @media only screen and (max-width: 1023px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media only screen and (max-width: 767px) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
        gap: 10px;
    }
`;

export const ChartsContainerMain = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;

    @media only screen and (max-width: 1023px) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }

    @media only screen and (max-width: 767px) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
        gap: 10px;
    }
`;